// src/store.js
import { configureStore } from "@reduxjs/toolkit";
import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";

import { combineReducers } from "redux";
import {
  authReducer,
  dealerListReducer,
  adminListReducer,
  dealerStatusReducer,
  dealerShareCredentialsReducer,
  clientReportReducer,
} from "../redux/reducers/authReducer";
import dashboardReducer from "../redux/reducers/dashboardReducer";

import orderReducer, {
  orderListReducer,
  orderStatisticsReducer,
  orderDownloadReducer,
  paymentReducer,
  fetchPaymentLisReducer,
  stateCityReducer,
  qrStatusByDateReducer,
  dealerAccessReducer,
  SloganReducer,
  orderQrStatusReducer,
  RedeemedSalesmanQrReducer,
} from "../redux/reducers/orderReducer";
import orderApproveReducer from "../redux/reducers/orderApproveReducer";
import processOrderReducer from "../redux/reducers/orderApproveReducer";
import fetchCustomerListReducer from "../redux/reducers/customerReducer";
import customerDetailsReducer from "../redux/reducers/consumerReducer";
import { promotionalRedeemReducer } from "../redux/reducers/consumerReducer";

import {
  consumerReducer,
  qrStatusReducer,
} from "../redux/reducers/consumerReducer";
import salesmanReducer from "../redux/reducers/salesmanReducer";
import giftReducer from "../redux/reducers/GiftReducer";
import bannerReducer from "../redux/reducers/bannerReducer";
import { qrDesignReducer } from "../redux/reducers/qrDesignReducer";
import { customerReducer } from "../redux/reducers/customerReducer";
import { customerRedemptionSummaryReducer } from "../redux/reducers/orderReducer"; // match your existing path
// import authReducer from '../features//auth/authSlice';
const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  order: orderReducer,
  orderList: orderListReducer,
  orderStatistics: orderStatisticsReducer,
  orderApprove: orderApproveReducer,
  // qrActivation: qrActivationReducer,
  consumerReducer: consumerReducer,
  qrStatus: qrStatusReducer,
  orderDownload: orderDownloadReducer,
  processOrder: processOrderReducer,
  payment: paymentReducer,
  paymentList: fetchPaymentLisReducer,
  stateCityStats: stateCityReducer,
  fetchCustomerList: fetchCustomerListReducer,
  dealerList: dealerListReducer,
  adminList: adminListReducer,
  dealerStatusList: dealerStatusReducer,
  dealerShare: dealerShareCredentialsReducer,
  clientReport: clientReportReducer,
  qrStatusByDate: qrStatusByDateReducer,
  dealerAccess: dealerAccessReducer,
  salesman: salesmanReducer,
  gift: giftReducer,
  banner: bannerReducer,
  qrDesign: qrDesignReducer,
  customer: customerReducer,
  slogan: SloganReducer,
  redemptionStats: RedeemedSalesmanQrReducer,
  customerDetails: customerDetailsReducer,
  promotionalRedeem: promotionalRedeemReducer,
  orderQrStatus: orderQrStatusReducer,
  customerRedemptionSummary: customerRedemptionSummaryReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
